import Slideshow from "../../classes/Slideshow";

export const initSlideshowFull  = () => {
	const components = Array.from(document.querySelectorAll(`section.slideshow-full`));
	
	if ( components.length )
	{
		components.forEach( ( component ) => {
			const bookmarksContainer = component.querySelector(`ul.buttons`);
			const slidesContainer = component.querySelector(`ul.slides`);
			const navsContainer = component.querySelector(`ul.nav`);

			if ( bookmarksContainer )
			{
				const slideshow = new Slideshow({
					slidesContainer,
					bookmarksContainer,
					navsContainer,
					loop: true,
					autoPlay: true,
				});

				slideshow._changeSlide(1);
			}
		});
	}
};
